const ALPHABET =
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

function digitValue(ch) {
  if (ch >= '0' && ch <= '9') return ch.charCodeAt(0) - 48;
  if (ch >= 'a' && ch <= 'z') return ch.charCodeAt(0) - 87;
  if (ch >= 'A' && ch <= 'Z') return ch.charCodeAt(0) - 29;
  throw new Error(`Invalid base62 character: ${ch}`);
}

export function encode62(value) {
  let n = Number(value);
  if (!Number.isFinite(n) || n < 0) n = 0;
  n = Math.floor(n);
  if (n === 0) return '0';

  let out = '';
  while (n > 0) {
    out = ALPHABET[n % 62] + out;
    n = Math.floor(n / 62);
  }
  return out;
}

export function decode62(encodedValue = '') {
  if (!encodedValue) return 0;
  let n = 0;
  for (const ch of String(encodedValue)) {
    n = n * 62 + digitValue(ch);
  }
  return n;
}

export function encode62Fixed(value, width) {
  return encode62(value).padStart(width, '0');
}
